// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"eZy_We"};